<div class="chats-page">
  <header class="chats-header">
    <div>
      <h2 class="chats-title">Integraciones de chat</h2>
      <p class="chats-subtitle">
        Conecta las plataformas que uses para buscar conversaciones de producto y recibir notificaciones personales.
      </p>
    </div>
  </header>

  <section class="provider-panel provider-slack" aria-labelledby="chats-slack-title">
    <div class="provider-panel-header">
      <div class="provider-brand">
        <span class="provider-icon provider-icon-slack" aria-hidden="true">
          <img src="assets/img/icons/slack.svg" alt="" class="provider-logo" />
        </span>
        <div>
          <h3 id="chats-slack-title" class="provider-title">Slack</h3>
          <p class="provider-description">
            Una conexión por workspace de cada company de tus productos activos
            @if (is_worker_user()) {
              (más Bisual)
            }
            .
          </p>
        </div>
      </div>
      <div class="provider-header-actions">
        @if (slots().length > 0) {
          <span class="provider-summary">{{ connected_slots_count() }}/{{ connectable_slots_count() }} conectados</span>
        }
        <button mat-stroked-button type="button" (click)="refresh_slots()" [disabled]="!can_view()">
          <mat-icon>refresh</mat-icon>
          Actualizar
        </button>
      </div>
    </div>

    @if (slots().length === 0) {
      <div class="provider-empty">
        <mat-icon>link_off</mat-icon>
        <p>No hay productos activos asociados a companies con o sin Slack.</p>
      </div>
    } @else {
      <ul class="slot-list">
        @for (slot of slots(); track slot.company_id) {
          <li class="slot-row" [class.slot-row-connected]="slot.is_connected" [class.slot-row-admin]="slot.needs_admin_configuration">
            <div class="slot-main">
              <img class="slot-logo" [src]="slot.display_logo_url" [alt]="slot.company_name" />
              <div class="slot-info">
                <div class="slot-title-row">
                  <p class="slot-title">{{ slot.company_name }}</p>
                  @if (slot.is_bisual) {
                    <span class="slot-badge">Bisual</span>
                  }
                  @if (slot.needs_admin_configuration) {
                    <span class="slot-status slot-status-admin">Pendiente de admin</span>
                  } @else {
                    <span class="slot-status" [class.slot-status-on]="slot.is_connected">
                      {{ slot.is_connected ? 'Conectado' : 'Sin conectar' }}
                    </span>
                  }
                </div>
                @if (slot.product_titles_label; as product_titles_label) {
                  <p class="slot-meta">Productos: {{ product_titles_label }}</p>
                }
                @if (slot.needs_admin_configuration) {
                  <p class="slot-meta slot-meta-admin">
                    Un administrador debe conectar Slack en la ficha de la empresa antes de que puedas vincular tu usuario.
                  </p>
                } @else {
                  <p class="slot-meta">
                    Workspace {{ slot.team_id }}
                    @if (slot.workspace_name) {
                      · {{ slot.workspace_name }}
                    }
                    @if (slot.is_connected && slot.external_user_id) {
                      · Usuario {{ slot.external_user_id }}
                    }
                  </p>
                }
              </div>
            </div>
            <div class="slot-actions">
              @if (slot.needs_admin_configuration) {
                <span class="slot-admin-hint">
                  <mat-icon>admin_panel_settings</mat-icon>
                  Configuración admin
                </span>
              } @else if (slot.is_connected) {
                <button
                  mat-stroked-button
                  color="warn"
                  type="button"
                  (click)="disconnect(slot)"
                  [disabled]="!can_disconnect() || disconnecting_id() === slot.connection_id"
                >
                  <mat-icon>link_off</mat-icon>
                  Desconectar
                </button>
              } @else {
                <button
                  mat-flat-button
                  color="accent"
                  type="button"
                  (click)="connect_slack(slot)"
                  [disabled]="!can_connect() || connecting_team_id() === slot.team_id"
                >
                  <mat-icon>link</mat-icon>
                  {{ connecting_team_id() === slot.team_id ? 'Abriendo Slack…' : 'Conectar' }}
                </button>
              }
            </div>
          </li>
        }
      </ul>
    }
  </section>

  <section class="provider-panel" aria-labelledby="chats-google-title">
    <div class="provider-panel-header">
      <div class="provider-brand">
        <span class="provider-icon provider-icon-google" aria-hidden="true">
          <img src="assets/img/icons/google-chat.svg" alt="" class="provider-logo" />
        </span>
        <div>
          <h3 id="chats-google-title" class="provider-title">Google Chat</h3>
          <p class="provider-description">
            Conversación personal (DM) vinculada a este usuario para buscar historial y contexto de producto. Un usuario solo puede tener un
            DM asignado.
          </p>
        </div>
      </div>
    </div>

    @if (google_conversation(); as conversation) {
      <div class="slot-card">
        <div>
          <p class="assignment-eyebrow">Conversación asignada</p>
          <strong>{{ google_conversation_label() }}</strong>
          @if (conversation.google_chat_space_name && conversation.google_chat_space_name !== google_conversation_label()) {
            <div class="slot-meta">{{ conversation.google_chat_space_name }}</div>
          }
        </div>
        @if (can_manage_personal_chats()) {
          <div class="slot-actions-stack">
            <button mat-stroked-button type="button" (click)="unassign_google_conversation()">
              <mat-icon>link_off</mat-icon>
              Quitar asignación
            </button>
            <p class="admin-only-hint">Solo visible para administradores / account managers</p>
          </div>
        }
      </div>
    } @else {
      <div class="slot-card slot-card--empty">
        <div>
          <p class="assignment-eyebrow">Sin asignación</p>
          <strong class="empty-assignment-title">Ningún DM vinculado</strong>
          <p class="slot-meta">Este usuario aún no tiene una conversación personal de Google Chat asignada.</p>
        </div>
        @if (can_manage_personal_chats()) {
          <div class="slot-actions-stack">
            <button mat-stroked-button type="button" (click)="assign_google_conversation()" [disabled]="assigning_google()">
              <mat-icon>link</mat-icon>
              {{ assigning_google() ? 'Cargando…' : 'Asignar conversación' }}
            </button>
            <p class="admin-only-hint">Elige un DM pendiente del catálogo. Solo visible para administradores / account managers.</p>
          </div>
        }
      </div>
    }
  </section>

  <section class="provider-panel" aria-labelledby="chats-teams-title">
    <div class="provider-panel-header">
      <div class="provider-brand">
        <span class="provider-icon provider-icon-teams" aria-hidden="true">
          <img src="assets/img/icons/microsoft-teams.svg" alt="" class="provider-logo" />
        </span>
        <div>
          <h3 id="chats-teams-title" class="provider-title">Microsoft Teams</h3>
          <p class="provider-description">
            Conversación 1:1 con el bot de Bisual vinculada a este usuario para notificaciones y contexto. Un usuario solo puede tener un
            chat Teams personal asignado.
          </p>
        </div>
      </div>
    </div>

    @if (teams_conversation(); as conversation) {
      <div class="slot-card">
        <div>
          <p class="assignment-eyebrow">Conversación asignada</p>
          <strong>{{ teams_conversation_label() }}</strong>
          @if (conversation.teams_tenant_id) {
            <div class="slot-meta">Tenant {{ conversation.teams_tenant_id }}</div>
          }
          @if (conversation.teams_conversation_type) {
            <div class="slot-meta">Tipo {{ conversation.teams_conversation_type }}</div>
          }
        </div>
        @if (can_manage_personal_chats()) {
          <div class="slot-actions-stack">
            <button mat-stroked-button type="button" (click)="unassign_teams_conversation()">
              <mat-icon>link_off</mat-icon>
              Quitar asignación
            </button>
            <p class="admin-only-hint">Solo visible para administradores / account managers</p>
          </div>
        }
      </div>
    } @else {
      <div class="slot-card slot-card--empty">
        <div>
          <p class="assignment-eyebrow">Sin asignación</p>
          <strong class="empty-assignment-title">Ningún chat Teams vinculado</strong>
          <p class="slot-meta">Este usuario aún no tiene una conversación 1:1 de Teams con el bot instalado asignada.</p>
        </div>
        @if (can_manage_personal_chats()) {
          <div class="slot-actions-stack">
            <button mat-stroked-button type="button" (click)="assign_teams_conversation()" [disabled]="assigning_teams()">
              <mat-icon>link</mat-icon>
              {{ assigning_teams() ? 'Cargando…' : 'Asignar conversación' }}
            </button>
            <p class="admin-only-hint">Elige un 1:1 pendiente con bot instalado. Solo visible para administradores / account managers.</p>
          </div>
        }
      </div>
    }
  </section>
</div>
